export enum Extention {
  XSLT = '.xslt',
  HTML = '.html',
  XML = '.xml',
  JPG = '.jpg',
  PNG = '.png'
}

export enum Product {
  EINVOICE = 'EINVOICE',
  EARCHIVE = 'EARCHIVE',
  ESMM = 'ESMM',
  EIRSALIYE = 'EIRSALIYE',
  EMM = 'EMM'
}
